import { useDispatch, useSelector } from 'react-redux';
import { setCurrentClinic } from 'Redux/modules/clinics/actions';
import dayjs from 'dayjs';

const LS_CURRENT_CLINIC_ID_KEY = 'current-clinic-id';
const LS_CURRENT_CLINIC_SET_TIME_KEY = 'current-clinic-set-time';

export const useCurrentClinic = () => {
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { currentClinicId } = useSelector(state => state.clinics);

  // Save to both local storage and redux store
  const saveCurrentClinic = (clinicId: number) => {
    if (!clinicId) {
      localStorage.removeItem(LS_CURRENT_CLINIC_ID_KEY);
      return;
    }

    localStorage.setItem(LS_CURRENT_CLINIC_ID_KEY, clinicId.toString(10));
    localStorage.setItem(LS_CURRENT_CLINIC_SET_TIME_KEY, dayjs().toISOString());

    dispatch(setCurrentClinic(clinicId));
  };

  /*
   * Force users to choose clinic again if:
   * - No clinicId or set time in local storage
   * - Today is not the same day as the set time
   * - User logout
   * */
  const isLSClinicValid = () => {
    const clinicId = localStorage.getItem(LS_CURRENT_CLINIC_ID_KEY);
    const setClinicTime = localStorage.getItem(LS_CURRENT_CLINIC_SET_TIME_KEY);

    if (!clinicId || !setClinicTime) {
      return false;
    }

    const now = dayjs();
    return now.isSame(dayjs(setClinicTime), 'day');
  };

  const clearCurrentClinic = () => {
    localStorage.removeItem(LS_CURRENT_CLINIC_ID_KEY);
    localStorage.removeItem(LS_CURRENT_CLINIC_SET_TIME_KEY);
  };

  const initCurrentClinicFromLS = () => {
    saveCurrentClinic(Number(localStorage.getItem(LS_CURRENT_CLINIC_ID_KEY)));
  };

  return {
    currentClinicId,
    saveCurrentClinic,
    isLSClinicValid,
    clearCurrentClinic,
    initCurrentClinicFromLS,
  };
};
